
window._alq = {
    
    queue: window._alq || [],
    queryId: null,
    
    push(data): void {
        // config
        if(data.config) {
            if(data.config.query_id) {
                this.queryId = data.config.query_id
            }
        }
        // event
        else if(data.event) {
            
            if(data.event.type == 'view_product') {
                this.send('other' ,'view', 'product', {
                    objectID: data.event.product_id,
                })
                
            } else if(data.event.type == 'view_video') {
                this.send('other' ,'view', 'product_video', {
                    objectID: data.event.product_id,
                })
                
            } else if(data.event.type == 'search_click_product') {
                this.send('search' ,'search_click', 'product', {
                    queryID: data.event.query_id || this.queryId || null,
                    objectID: data.event.product_id,
                    position: data.event.position
                })
                
            } else if(data.event.type == 'search_click_category') {
                this.send('search', 'search_click', 'category', {
                    queryID: data.event.query_id || this.queryId || null,
                    objectID: data.event.category_id,
                    position: data.event.position
                })
                
            } else if(data.event.type == 'search_click_page') {
                this.send('search', 'search_click', 'page', {
                    queryID: data.event.query_id || this.queryId || null,
                    objectID: data.event.page_id,
                    position: data.event.position
                })
                
            } else if(data.event.type == 'suggest_click_product') {
                this.send('suggest' ,'search_click', 'product', {
                    queryID: data.event.query_id || this.queryId || null,
                    objectID: data.event.product_id,
                    position: data.event.position
                })
                
            } else if(data.event.type == 'suggest_click_category') {
                this.send('suggest' ,'search_click', 'category', {
                    queryID: data.event.query_id || this.queryId || null,
                    objectID: data.event.category_id,
                    position: data.event.position
                })
                
            } else if(data.event.type == 'suggest_click_page') {
                this.send('suggest' ,'search_click', 'page', {
                    queryID: data.event.query_id || this.queryId || null,
                    objectID: data.event.page_id,
                    position: data.event.position
                })
                
            } else if(data.event.type == 'suggest_click_term') {
                this.send('suggest' ,'search_click', 'term', {
                    queryID: data.event.query_id || this.queryId || null,
                    objectID: data.event.term,
                    position: data.event.position
                })
                
            } else if(data.event.type == 'click_product') {
                this.send('other', 'click', 'product', {
                    objectID: data.event.product_id,
                })
                
            } else if(data.event.type == 'add_to_wishlist') {
                const query_id = data.event.query_id || this.queryId || null
                if(query_id) {
                    this.send('wishlist', 'search_conversion', 'product', {
                        objectID: data.event.product_id,
                        queryID: query_id
                    })
                } else {
                    this.send('wishlist' ,'conversion', 'product', {
                        'objectIDs[0]': data.event.product_id,
                    })
                }                
                
            } else if(data.event.type == 'add_to_cart') {
                const query_id = data.event.query_id || this.queryId || null
                if(query_id) {
                    this.send('cart', 'search_conversion', 'product', {
                        objectID: data.event.product_id,
                        queryID: query_id
                    })
                } else {
                    this.send('cart', 'conversion', 'product', {
                        'objectIDs[0]': data.event.product_id,
                    })
                }
            }
        }
    },
    
    send(eventContext, eventName, resultType, params): void {
        if(window.elumeo.is_dev_environment) {
            console.log({
                eventContext: eventContext,
                eventName: eventName,
                resultType: resultType,
                params: params
            })
        }
        
        const form = new FormData()
        for(const [key, value] of Object.entries(params)) {
            form.append(key, value+'')
        }
        const options = <RequestInit>{
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(form),
            keepalive: true,
            credentials: 'include'
        }
        fetch('/search/event/'+eventContext+'/'+eventName+'/'+resultType, options).catch(error => {
            if(window.elumeo.is_dev_environment) {
                console.log(error)
            }
        })
    },
    
    init(): void {
        while(this.queue.length > 0) {
            this.push(this.queue.shift())
        }
    }
}

window._alq.init()

/**
 * auto-click-handler on search-result
 */
document.querySelectorAll('*[x-alg-search-click]').forEach((item) => {
    item.addEventListener('click', () => {
        const [ productId, position ] = item.getAttribute('x-alg-search-click').split(':')
        window._alq.push({ 
            event: {
                type: 'search_click_product',
                product_id: productId,
                position: parseInt(position)
            }
        })
    })
})

document.querySelectorAll('*[x-alg-click]').forEach((item) => {
    item.addEventListener('click', () => {
        window._alq.push({
            event : {
                type: 'click_product',
                product_id: item.getAttribute('x-alg-click')
            }
        })
    })
})